import { render, staticRenderFns } from "./CollectionTelpersonnelAccountList.vue?vue&type=template&id=aedac88c&scoped=true"
import script from "./CollectionTelpersonnelAccountList.vue?vue&type=script&lang=js"
export * from "./CollectionTelpersonnelAccountList.vue?vue&type=script&lang=js"
import style0 from "./CollectionTelpersonnelAccountList.vue?vue&type=style&index=0&id=aedac88c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aedac88c",
  null
  
)

export default component.exports